import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { MapPin, ArrowRight } from 'lucide-react';

export default function QuickLinks() {
  const { t } = useTranslation();

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-gray-50 border-y border-gray-200">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12">
        
        {/* Academic Calendar Link - NSCC Style */}
        <div className="bg-white p-8 md:p-10 flex flex-col sm:flex-row gap-8 shadow-md hover:shadow-xl transition-all duration-300 border-b-4 border-gold rounded-sm group overflow-hidden">
          <div className="w-full sm:w-32 h-32 flex-shrink-0 bg-gray-100 p-1 rounded-sm overflow-hidden border border-gray-100">
            <img 
              src="/images/campus/activity-01.jpg" 
              alt="Calendrier" 
              className="w-full h-full object-cover grayscale opacity-70 group-hover:grayscale-0 group-hover:opacity-100 group-hover:scale-110 transition-all duration-700"
              loading="lazy"
            />
          </div>
          <div className="flex-1 flex flex-col">
            <h3 className="text-navy text-2xl font-black mb-4 uppercase tracking-tighter">
              {t('admissions_calendar_title', 'Calendrier Académique')}
            </h3>
            <p className="text-gray-600 mb-8 text-sm leading-relaxed font-light">
              {t('calendar_desc_short', 'Dates importantes pour les admissions, les formations du collège et les jours fériés.')}
            </p>
            <Link 
              to="/closures" 
              className="mt-auto inline-flex items-center gap-2 text-navy font-black underline hover:text-gold uppercase tracking-widest text-xs transition-colors group/link"
            >
              {t('link_view_calendar', 'Voir le calendrier')}
              <ArrowRight className="w-4 h-4 transition-transform group-hover/link:translate-x-1" />
            </Link>
          </div>
        </div>

        {/* Explore Campus Link - NSCC Style */}
        <div className="bg-white p-8 md:p-10 flex flex-col sm:flex-row gap-8 shadow-md hover:shadow-xl transition-all duration-300 border-b-4 border-gold rounded-sm group overflow-hidden">
          <div className="w-full sm:w-32 h-32 flex-shrink-0 bg-gray-100 p-1 rounded-sm overflow-hidden border border-gray-100">
            <img 
              src="/images/campus/entrance.jpg" 
              alt="Campus" 
              className="w-full h-full object-cover grayscale opacity-70 group-hover:grayscale-0 group-hover:opacity-100 group-hover:scale-110 transition-all duration-700"
              loading="lazy"
            />
          </div>
          <div className="flex-1 flex flex-col">
            <h3 className="text-navy text-2xl font-black mb-4 uppercase tracking-tighter">
              {t('explore_campus_title', 'Explorer le Campus')}
            </h3>
            <div className="flex items-center gap-2 mb-4 text-gold font-bold text-[10px] uppercase tracking-widest">
              <MapPin className="w-4 h-4" />
              {t('hero_card_city', 'Palais des Congrès, Yaoundé')}
            </div>
            <p className="text-gray-600 mb-8 text-sm leading-relaxed font-light">
              {t('explore_campus_desc_short', 'Découvrez nos installations modernes situées au cœur de la capitale politique.')}
            </p>
            <Link 
              to="/campus" 
              className="mt-auto inline-flex items-center gap-2 text-navy font-black underline hover:text-gold uppercase tracking-widest text-xs transition-colors group/link"
            >
              {t('link_virtual_tour', 'Visite virtuelle')}
              <ArrowRight className="w-4 h-4 transition-transform group-hover/link:translate-x-1" />
            </Link>
          </div>
        </div>

      </div>
    </section>
  );
}
